module.exports = __webpack_public_path__ + "img/letter.fc0b8d0d.png";